/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayoutDistribution
 */
export interface PayoutDistribution {
    /**
     * Finishing position (1, 2, 3, etc.)
     * @type {number}
     * @memberof PayoutDistribution
     */
    place?: number;
    /**
     * Percentage of prize pool (must sum to 100)
     * @type {number}
     * @memberof PayoutDistribution
     */
    percentage?: number;
    /**
     * Display label such as 1st Place
     * @type {string}
     * @memberof PayoutDistribution
     */
    label?: string;
}

/**
 * Check if a given object implements the PayoutDistribution interface.
 */
export function instanceOfPayoutDistribution(value: object): value is PayoutDistribution {
    return true;
}

export function PayoutDistributionFromJSON(json: any): PayoutDistribution {
    return PayoutDistributionFromJSONTyped(json, false);
}

export function PayoutDistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutDistribution {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function PayoutDistributionToJSON(json: any): PayoutDistribution {
    return PayoutDistributionToJSONTyped(json, false);
}

export function PayoutDistributionToJSONTyped(value?: PayoutDistribution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'percentage': value['percentage'],
        'label': value['label'],
    };
}

